<template>
  <div class="container mt-4">
    <h2 class="text-center mb-4">Gestión de Usuarios y Roles</h2>

    <!-- Filtros para Roles -->
    <div class="row mb-3">
      <div class="col-md-6">
        <label for="roleFilter">Filtrar por Rol:</label>
        <select v-model="selectedRole" class="form-select" @change="filtrarUsuarios">
          <option value="">Todos los Roles</option>
          <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.nombre }}</option>
        </select>
      </div>
      <div class="col-md-6 d-flex align-items-end">
        <button class="btn btn-primary w-100" @click="abrirModal(null)">Agregar Usuario</button>
      </div>
    </div>
    <!-- BUSCADOR -->
    <div class="mb-3">
      <input type="text" v-model="busquedaTexto" class="form-control" placeholder="Buscar por nombre o email..." />
    </div>


    <!-- Tabla de Usuarios -->
    <table class="table table-striped">
      <thead>
        <tr>
          <th>id</th>
          <th @click="ordenarUsuarios('nombre')">Nombre</th>
          <th @click="ordenarUsuarios('email')">Email</th>
          <th @click="ordenarUsuarios('club')">Club</th>
          <th @click="ordenarUsuarios('role')">Rol</th>
          <th>Activo</th>
          <th>Eliminado</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in usuariosFiltradosPaginados" :key="user.id">
          <td>{{ user.id }}</td>
          <td>{{ user.nombre }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.club ? user.club.nombre : 'Sin club' }}</td>
          <td>{{ user.role ? user.role.nombre : 'Sin rol' }}</td>
          <td>{{ user.is_active ? 'Sí' : 'No' }}</td>
          <td>{{ user.is_deleted ? 'Sí' : 'No' }}</td>

          <td>
            <button class="btn btn-sm btn-outline-secondary me-2" @click="abrirModal(user)">Editar</button>
            <button class="btn btn-sm btn-outline-danger" @click="eliminarUsuario(user.id)">Eliminar</button>
            <button class="btn btn-sm btn-outline-danger" @click="eliminarUsuarioFull(user.id)">Eliminar Full</button>


          </td>
        </tr>
      </tbody>
    </table>

    <!-- Vista en tarjetas para mobile -->
<div class="d-md-none">
  <div class="user-card mb-3 p-3 border rounded" v-for="user in usuariosFiltradosPaginados" :key="user.id">
    <h5 class="mb-1">{{ user.nombre }}</h5>
    <p class="mb-1"><strong>Email:</strong> {{ user.email }}</p>
    <p class="mb-1"><strong>Club:</strong> {{ user.club ? user.club.nombre : 'Sin club' }}</p>
    <p class="mb-1"><strong>Rol:</strong> {{ user.role ? user.role.nombre : 'Sin rol' }}</p>
    <p class="mb-1"><strong>Activo:</strong> {{ user.is_active ? 'Sí' : 'No' }}</p>
    <p class="mb-1"><strong>Eliminado:</strong> {{ user.is_deleted ? 'Sí' : 'No' }}</p>
    <div class="mt-2 d-flex gap-2 flex-wrap">
      <button class="btn btn-sm btn-outline-secondary" @click="abrirModal(user)">Editar</button>
      <button class="btn btn-sm btn-outline-danger" @click="eliminarUsuario(user.id)">Eliminar</button>
      <button class="btn btn-sm btn-outline-danger" @click="eliminarUsuarioFull(user.id)">Eliminar Full</button>
    </div>
  </div>
</div>



    <!-- Paginación -->
    <nav aria-label="Paginación" class="mt-3">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: paginaActual === 1 }">
          <a class="page-link" href="#" @click.prevent="paginaActual--">Anterior</a>
        </li>
        <li class="page-item" v-for="pagina in totalPaginas" :key="pagina" :class="{ active: paginaActual === pagina }">
          <a class="page-link" href="#" @click.prevent="paginaActual = pagina">{{ pagina }}</a>
        </li>
        <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
          <a class="page-link" href="#" @click.prevent="paginaActual++">Siguiente</a>
        </li>
      </ul>
    </nav>


    <!-- Modal para Crear/Editar Usuarios -->
    <div v-if="mostrarModal" class="modal-overlay">
      <div class="modal-content">
        <h4>{{ usuarioSeleccionado ? 'Editar Usuario' : 'Agregar Usuario' }}</h4>
        <form @submit.prevent="confirmarGuardarUsuario">
          <div class="mb-3">
            <label for="nombreUsuario" class="form-label">Nombre</label>
            <input type="text" class="form-control" v-model="nuevoUsuario.nombre" required />
          </div>
          <div class="mb-3">
            <label for="emailUsuario" class="form-label">Email</label>
            <input type="email" class="form-control" v-model="nuevoUsuario.email" required />
          </div>
          <div class="mb-3">
            <label for="passwordUsuario" class="form-label">Contraseña</label>
            <input type="password" class="form-control" v-model="nuevoUsuario.password"
              :required="!usuarioSeleccionado" />
          </div>
          <!-- club -->
          <div class="mb-3">
            <label for="clubUsuario" class="form-label">Club</label>
            <select v-model="nuevoUsuario.club_id" class="form-select">
              <option value="">Sin club</option>
              <option v-for="club in clubs" :key="club.id" :value="club.id">{{ club.nombre }}</option>
            </select>
          </div>
          <div class="mb-3">
            <label for="roleUsuario" class="form-label">Rol</label>
            <select v-model="nuevoUsuario.role_id" class="form-select" required>
              <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.nombre }}</option>
            </select>
          </div>
          <!-- usuario activo -->
          <div class="mb-3">
            <label for="activoUsuario" class="form-label">Activo</label>
            <input type="checkbox" class="form-check-input" v-model="nuevoUsuario.is_active" />
          </div>
          <button type="submit" class="btn btn-success">Guardar</button>
          <button type="button" class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  data() {
    return {
      usuarios: [],
      roles: [],
      clubs: [],
      usuariosFiltrados: [],
      selectedRole: '',
      mostrarModal: false,
      usuarioSeleccionado: null,
      busquedaTexto: '',
      paginaActual: 1,
      porPagina: 10,

      nuevoUsuario: {
        nombre: '',
        email: '',
        password: '',
        role_id: '',
        is_active: true,
        club_id: '',
        is_deleted: false,
      },
    };
  },
  computed: {
    usuariosFiltradosPaginados() {
      let filtrados = this.usuarios.filter(user =>
        user.nombre?.toLowerCase().includes(this.busquedaTexto.toLowerCase()) ||
        user.email?.toLowerCase().includes(this.busquedaTexto.toLowerCase())
      );

      // Aplicar filtro de rol si está seleccionado
      if (this.selectedRole) {
        filtrados = filtrados.filter(u => u.role_id === this.selectedRole);
      }

      // Calcular paginación
      const inicio = (this.paginaActual - 1) * this.porPagina;
      return filtrados.slice(inicio, inicio + this.porPagina);
    },
    totalPaginas() {
      let total = this.usuarios.filter(user =>
        user.nombre?.toLowerCase().includes(this.busquedaTexto.toLowerCase()) ||
        user.email?.toLowerCase().includes(this.busquedaTexto.toLowerCase())
      );
      if (this.selectedRole) {
        total = total.filter(u => u.role_id === this.selectedRole);
      }
      return Math.ceil(total.length / this.porPagina) || 1;
    },
  },



  methods: {
    async cargarDatos() {
      try {
        const [usuariosRes, rolesRes, clubesRes] = await Promise.all([
          axios.get('/api/usuarios', {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          }),
          axios.get('/api/roles', {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          }),
          axios.get('/api/clubes', {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          }),
        ]);
        this.usuarios = usuariosRes.data;
        this.usuariosFiltrados = this.usuarios;
        this.roles = rolesRes.data;
        this.clubs = clubesRes.data;

      } catch (error) {
        console.error('Error al cargar datos:', error);
      }
    },
    filtrarUsuarios() {
      this.usuariosFiltrados = this.usuarios.filter((user) => {
        return this.selectedRole ? user.role_id === this.selectedRole : true;
      });
    },
    ordenarUsuarios(campo) {
      this.usuariosFiltrados.sort((a, b) => (a[campo] > b[campo] ? 1 : -1));
    },
    abrirModal(user) {
      this.usuarioSeleccionado = user;
      this.clubAnterior = user?.club_id || null;

      this.nuevoUsuario = user
        ? { ...user, password: '' }
        : { nombre: '', email: '', password: '', role_id: '', is_active: true, club_id: '' };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.usuarioSeleccionado = null;
    },
    async confirmarGuardarUsuario() {
      try {

        //mensaje de confirmación si desea guardar los cambios
        if (confirm('¿Estás seguro de que deseas guardar los cambios?')) {
          if (this.usuarioSeleccionado) {
            const id = this.usuarioSeleccionado.id;
            this.nuevoUsuario.user_id = id;
            await axios.put('/api/usuarios/', this.nuevoUsuario, {
              headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });


            // 🔄 Si cambió el club, actualizar en Vuex
            if (this.clubAnterior !== this.nuevoUsuario.club_id) {
              const nuevoClub = this.clubs.find(club => club.id === this.nuevoUsuario.club_id);
              if (nuevoClub) {
                this.$store.commit('setClubActual', nuevoClub);
              }
            }
          } else {
            await axios.post('/api/auth/usuarios', this.nuevoUsuario, {
              headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
          }
          this.cerrarModal();
          this.cargarDatos();
        }



      } catch (error) {
        console.error('Error al guardar usuario:', error);
      }
    },
    async eliminarUsuario(id) {
      if (confirm('¿Estás seguro de que deseas eliminar este usuario?')) {
        try {
          const user_id = id;
          //agregar el user al parametro de la url
          await axios.delete(`/api/usuarios/${user_id}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          });


          this.cargarDatos();
        } catch (error) {
          console.error('Error al eliminar usuario:', error);
          alert(error.response.data.error);
        }
      }
    },
    async eliminarUsuarioFull(id) {
      if (confirm('¿Estás seguro de que deseas eliminar este usuario?')) {
        try {
          const user_id = id;
          //agregar el user al parametro de la url
          await axios.delete(`/api/usuarios/${user_id}/full`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          });


          this.cargarDatos();
        } catch (error) {
          console.error('Error al eliminar usuario:', error);
          alert(error.response.data.error);
        }
      }
    },
  },
  mounted() {
    this.cargarDatos();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  z-index: 1060;
}



/* Ocultar tabla en pantallas pequeñas */
@media (max-width: 768px) {
  .table {
    display: none;
  }
}

/* Estilo para tarjetas */
.user-card {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border-left: 5px solid var(--app-primary, #007bff);
}

/* Ajustes adicionales para input y botones */
@media (max-width: 576px) {
  .btn {
    font-size: 0.9rem;
    padding: 8px 12px;
  }

  .form-select,
  .form-control {
    font-size: 0.9rem;
  }

  .table th,
  .table td {
    font-size: 0.85rem;
  }
}

</style>